import React, { useCallback, useEffect, useRef, useState } from "react"

export function CustomSelect({ options, value, onChange, selectArrowIcon }) {
  const [isSelectVisible, setIsSelectVisible] = useState(false)
  const inputRef = useRef(null)
  const selectorRef = useRef(null)
  const boxRef = useRef(null)

  const onScroll = useCallback(() => {
    if (!boxRef.current || !selectorRef.current) {
      return
    }

    const box = boxRef.current.getBoundingClientRect()
    const selector = selectorRef.current.getBoundingClientRect()
    if (selector.bottom > window.innerHeight - box.height) {
      boxRef.current.style = `top: -${box.height - 1}px`
    } else {
      boxRef.current.style = undefined
    }
  }, [
    boxRef,
    boxRef.current,
    selectorRef,
    selectorRef.current,
    window.innerHeight,
  ])

  useEffect(() => {
    document.addEventListener("scroll", onScroll)
    document.addEventListener("touchmove", onScroll)
    return () => {
      document.removeEventListener("scroll", onScroll)
      document.removeEventListener("touchmove", onScroll)
    }
  }, [onScroll])

  useEffect(() => {
    if (isSelectVisible) {
      onScroll()
    }
  }, [isSelectVisible])

  const onOptionClick = useCallback(
    (v) => {
      onChange(v)
      inputRef.current?.blur()
    },
    [onChange, inputRef, inputRef.current],
  )

  return (
    <div className="custom-select">
      <div
        tabIndex={0}
        className="dummy-input"
        ref={inputRef}
        onFocus={() => setIsSelectVisible(true)}
        onBlur={() => setIsSelectVisible(false)}
      />
      <div
        ref={selectorRef}
        className="select-box"
        onClick={() => inputRef.current?.focus()}
      >
        <span className="selector-text">
          {options?.find((o) => o.value === value)?.label}
          <img src={selectArrowIcon} />
        </span>
      </div>
      {isSelectVisible && (
        <div ref={boxRef} className="select-options-wrapper">
          {options?.map(({ label, value }, i) => (
            <div
              onClick={() => onOptionClick(value)}
              onMouseDown={(e) => e.preventDefault()}
              key={value}
              className="select-option"
            >
              <span>{label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
